<template>
  <a
    href="#"
    class="social-btn whatsapp-btn"
    :style="loginButtonStyles"
    @click.prevent="showWhatsAppFields"
  >
    <i v-show="baseData.flags.loginBtnIcons" class="fa fa-whatsapp" />
    <span v-text="$t('whatsapp')" />
  </a>
</template>

<script>
  import { logUserAction } from '../../utils/logging'
  export default {
    name: 'WhatsAppButton',
    computed: {
      baseData() {
        return this.$store.state.baseData
      },
      loginButtonStyles() {
        return {
          background: this.loginButtonColor || '#25D366',
          color: this.loginButtonTextColor || '#ffffff',
          'justify-content':
            this.baseData.layouts.appLayout === 'app'
              ? 'center'
              : this.loginButtontextAlignment || 'flex-start',
        }
      },
      loginButtontextAlignment() {
        return this.baseData.fonts.alignments.loginBtns
      },
      loginButtonColor() {
        return this.baseData.colors.loginBtns.whatsappBtn
      },
      loginButtonTextColor() {
        return this.baseData.colors.loginBtns.loginBtnText
      },
    },
    methods: {
      showWhatsAppFields() {
        logUserAction({ type: 'user_action', label: 'User Clicked WhatsApp Connect Button' })
        this.$eventHub.$emit('showWhatsApp', true)
      },
    },
  }
</script>

<style>
  .whatsapp-btn {
    background: #25D366;
  }
  .whatsapp-btn:hover {
    background: #1d9b4d;
  }
</style>
